export class ScheduleRepository {
    private httpService: IHttpService
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }
    async getSchedules(employee_ids?: number[], start_date?: string, end_date?: string): Promise<ShiftSchema[]> {
        const response = await this.httpService.get<TKResponse<ShiftSchema[]>>("/shift/schedule", { params: {
            employee_ids: employee_ids?.join(","),
            start_date,
            end_date
        } });
        return response.data;
    }
    async getScheduleById(scheduleId: number): Promise<ShiftSchema> {
        const response = await this.httpService.get<TKResponse<ShiftSchema>>(`/shift/${scheduleId}`);
        return response.data;
    }
    async createSchedule(data: ShiftCreate): Promise<ShiftSchema> {
        const response = await this.httpService.post<TKResponse<ShiftSchema>, ShiftCreate>(`/shift`, {data});
        return response.data;
    }
    async updateSchedule(scheduleId: number, data: ShiftSchemaUpdate): Promise<ShiftSchema> {
        const response = await this.httpService.patch<TKResponse<ShiftSchema>, ShiftSchemaUpdate>(`/shift/${scheduleId}`, {data});
        return response.data;
    }
    async deleteSchedule(scheduleId: number): Promise<void> {
        await this.httpService.delete<void>(`/shift/${scheduleId}`);
    }
}